var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.94 145.8H43.8398",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.94 101.86V59.17V53.47V41C118.94 37.6863 116.254 35 112.94 35H49.8398C46.5261 35 43.8398 37.6863 43.8398 41V53.47V101.86",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.84 101.86L41.42 123.83L39.5299 140.989C39.2471 143.557 41.2573 145.8 43.84 145.8V145.8H118.94V145.8C121.28 145.8 123.11 143.781 122.879 141.452L121.13 123.83L119.71 109.62L118.94 101.86",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.94 53.4697C118.94 53.4697 104.31 59.1697 81.1598 59.1697C58.0098 59.1697 43.8398 53.4697 43.8398 53.4697",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.709 109.62H134.779C138.093 109.62 140.779 106.934 140.779 103.62V65.1699C140.779 61.8562 138.093 59.1699 134.779 59.1699H124.939C121.626 59.1699 118.939 61.8562 118.939 65.1699V101.86",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.13 123.83H41.4199",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeerIcon);
export default __webpack_public_path__ + "static/media/beer-icon.72ac2b970b853118dc1c962a96aeaabd.svg";
export { ForwardRef as ReactComponent };